import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TenantChannelUpdateModel } from "src/app/models/tenants/tenant-channel-update.model";
import { TenantChannelModel } from "src/app/models/tenants/tenant-channel.model";
import { Configuration } from "src/assets/Configuration";

@Injectable({
  providedIn: 'root',
})
export class TenantChannelService {

  constructor(private httpClient: HttpClient) {
  }

  public getAllTenantChannels(): Observable<TenantChannelModel[]> {
    return this.httpClient.get<TenantChannelModel[]>(
      Configuration.getApiBaseUrl() + '/tenantchannel'
    );
  }

  public getInternalTenantChannel(): Observable<TenantChannelModel> {
    return this.httpClient.get<TenantChannelModel>(
      Configuration.getApiBaseUrl() + '/tenantchannel/internal'
    );
  }

  public getExternalTenantChannels(): Observable<TenantChannelModel[]> {
    return this.httpClient.get<TenantChannelModel[]>(
      Configuration.getApiBaseUrl() + '/tenantchannel/external'
    );
  }

  public getTenantChannel(id: string): Observable<TenantChannelModel> {
    return this.httpClient.get<TenantChannelModel>(
      Configuration.getApiBaseUrl() + '/tenantchannel/' + id
    );
  }

  public addTenantChannel(model: TenantChannelUpdateModel): Observable<TenantChannelModel> {
    return this.httpClient.post<TenantChannelModel>(
      Configuration.getApiBaseUrl() + '/tenantchannel', 
      model
    );
  }

  public updateTenantChannel(id: string, model: TenantChannelUpdateModel): Observable<TenantChannelModel> {
    return this.httpClient.post<TenantChannelModel>(
      Configuration.getApiBaseUrl() + '/tenantchannel/' + id,
      model
    );
  }

  public deleteTenantChannel(id: string): Observable<void> {
    return this.httpClient.delete<void>(
      Configuration.getApiBaseUrl() +  '/tenantchannel/' + id
    );
  }
}